









import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import Element from 'element-ui'

@Component({
  components: {
  }
})
export default class BtnAdvancedSearch extends Vue {
  public name = 'BtnAdvancedSearch'

  //点击查询事件
  @Prop({ default: null })
  //:submit="function"
  public search!: () => void
  //由父级传入，如需反向更新父级，则父级调用时需加.sync方法 如:advance.sync='参数'
  @Prop({ default: false })
  public advance!: boolean
  //是否带高级文字
  @Prop({ default: true })
  public showText!: boolean
  public doSearch() {
    if (this.search) {
      this.search()
    }
  }
  public toggle() {
    //该句实现父子组件数据双向绑定，父组件通过sync绑定参数。使用方法 父:advance.sync='showMore'
    this.$emit('update:advance', !this.advance)
  }

  public $refs!: {
  }
}
